import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
    codigo?: string;
    descricao?: string;
    status?: number;
};

type Action = {
    setCodigo: (codigo: string | undefined) => void,
    setDescricao: (descricao: string | undefined) => void,
    setStatus: (status: number) => void,
    clearFilters: () => void
};

export const useChecklistEntregaListaFilters = create<State & Action>((set) => ({
    codigo: undefined,
    descricao: undefined,
    status: 2,
    setCodigo: (codigo) => set({ codigo }),
    setDescricao: (descricao) => set({ descricao }),
    setStatus: (status) => set({ status }),
    clearFilters: () => set({
        codigo: undefined,
        descricao: undefined,
        status: 2,
    }),
}));

export const initialChecklistEntregaFiltersValues: State = {
    codigo: undefined,
    descricao: undefined,
    status: 2,

}